import React from "react";
import Modal from "react-modal";

export const ImagePreview = ({ src, onClose }) => (
  <Modal
    isOpen={Boolean(src)}
    onRequestClose={onClose}
    contentLabel="Uploaded image preview"
    appElement={document.getElementById("root")}
    className="admin-image-preview"
    overlayClassName="admin-image-overlay"
    shouldCloseOnOverlayClick
    shouldCloseOnEsc
  >
    <button autoFocus type="button" className="admin-image-close" onClick={onClose}>
      Close ×
    </button>
    <img src={src} alt="Uploaded payment screenshot" />
  </Modal>
);
